// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e7px","title":"styles_title__QpO3D"};